// Access telemetryStackStorage at runtime via require so tests can inject a fake into require.cache
const getTelemetryStackStorageModule = () => require('./telemetryStackStorage');
import { DeviceTelemetryType } from '@signageos/common-types/dist/Device/Telemetry/DeviceTelemetryType';
import { TelemetryStackEntry } from './telemetryStackStorage';

export const shouldReportTelemetry = async (isDeviceSettingsChanged: Boolean, telemetryType: DeviceTelemetryType) => {
	const stackableTelemetries = [DeviceTelemetryType.CPU_USAGE, DeviceTelemetryType.MEMORY_USAGE];
	let shouldReturn: Boolean = false;

	if (isDeviceSettingsChanged) {
		shouldReturn = true;
	}

	if (stackableTelemetries.includes(telemetryType)) {
		const telemetryStack = getTelemetryStackStorageModule().telemetryStackStorage;
		const entries = (await telemetryStack.getLastEntries(telemetryType, 10)).map(
			(item: TelemetryStackEntry<typeof telemetryType>) => (item.data as { usage: number }).usage,
		);
		shouldReturn = shouldSendAlert(entries.slice(0, -1), entries[entries.length - 1]);
	}

	return shouldReturn;
};

/**
 * Calculates the mean (average) of a set of numbers.
 * @param data - An array of numbers.
 * @returns The mean of the numbers.
 */
const calculateMean = (data: number[]): number => {
	if (data.length === 0) {
		return 0;
	}
	const sum = data.reduce((acc, value) => acc + value, 0);
	return sum / data.length;
};

/**
 * Calculates the sample standard deviation of a set of numbers.
 * @param data - An array of numbers.
 * @param mean - The mean of the data array.
 * @returns The sample standard deviation.
 */
const calculateStdDev = (data: number[], mean: number): number => {
	if (data.length < 2) {
		return 0; // Standard deviation requires at least 2 data points.
	}
	const variance = data.reduce((acc, value) => acc + Math.pow(value - mean, 2), 0) / (data.length - 1);
	return Math.sqrt(variance);
};

const shouldSendAlert = (historicalUsage: number[], newUsageValue: number): boolean => {
	const lastOnePlusNew = [historicalUsage[historicalUsage.length - 1], newUsageValue];
	const lastButOneAndLast = historicalUsage.slice(-2);
	const stdDevOfLastTwo = Math.round(calculateStdDev(lastOnePlusNew, calculateMean(lastOnePlusNew)) * 100) / 100;
	const stdDevOfTwoHistorical = Math.round(calculateStdDev(lastButOneAndLast, calculateMean(lastButOneAndLast)) * 100) / 100;

	if (stdDevOfLastTwo > 7) {
		return true;
	}

	const diffBetweenTwoLastENtries = Math.abs(Math.round((stdDevOfLastTwo - stdDevOfTwoHistorical) * 100)) / 100;
	if (diffBetweenTwoLastENtries <= 0.1) {
		return true;
	}

	return false;
};
